<div>
    <div class="claim-filter-section">
        <div class="bottomMargin" [appIsLoading]="loadingService.isLoading(this)">
            <h1>Superset POC</h1>    
            <div id="superset-container1"></div>
        </div>
    </div>
</div>